import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _class, _class2, _descriptor, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "4e6c5tSCUdOjroKtzsqFgml", "WaggleAct", undefined);

// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html
import { _decorator, Component, Enum, tween, v3 } from "cc";
var ccclass = _decorator.ccclass,
    property = _decorator.property,
    menu = _decorator.menu;
export var E_WaggleAct;

(function (E_WaggleAct) {
  E_WaggleAct[E_WaggleAct["Normal"] = 0] = "Normal";
  E_WaggleAct[E_WaggleAct["Box"] = 1] = "Box";
})(E_WaggleAct || (E_WaggleAct = {}));

var WaggleAct = (_dec = menu("act/WaggleAct"), _dec2 = property({
  type: Enum(E_WaggleAct)
}), ccclass(_class = _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(WaggleAct, _Component);

  function WaggleAct() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "type", _descriptor, _assertThisInitialized(_this));

    return _this;
  }

  var _proto = WaggleAct.prototype;

  // LIFE-CYCLE CALLBACKS:
  // onLoad () {}
  _proto.start = function start() {};

  _proto.act = function act() {
    switch (this.type) {
      case E_WaggleAct.Normal:
        this.handle_Normal();
        break;

      case E_WaggleAct.Box:
        this.handle_Box();
        break;
    }
  };

  _proto.handle_Normal = function handle_Normal() {};

  _proto.handle_Box = function handle_Box() {
    tween(this.node).repeat(5, tween().to(0.1, {
      angle: Math.random() * 8 + 8
    }).to(0.1, {
      angle: -Math.random() * 8 - 8
    })).to(0.01, {
      angle: 0
    }).to(0.2, {
      scale: v3(3, 3)
    }).to(0.01, {
      scale: v3(1, 1)
    }).start();
  } // update (dt) {}
  ;

  return WaggleAct;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return E_WaggleAct.Normal;
  }
})), _class2)) || _class) || _class);
export { WaggleAct as default };

_cclegacy._RF.pop();